import { render, staticRenderFns } from "./VisualizarAbasDialog.vue?vue&type=template&id=2b6b8055&scoped=true"
import script from "./VisualizarAbasDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarAbasDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarAbasDialog.vue?vue&type=style&index=0&id=2b6b8055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b8055",
  null
  
)

export default component.exports